var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9739_6344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8435 13.5946C26.8435 12.5042 26.7568 11.7085 26.5694 10.8833H14.3813V15.8049H21.5355C21.3913 17.028 20.6124 18.87 18.8815 20.1077L18.8573 20.2725L22.7109 23.3224L22.9779 23.3496C25.4299 21.0361 26.8435 17.6321 26.8435 13.5946Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3814 26.562C17.8863 26.562 20.8287 25.3831 22.9779 23.3497L18.8816 20.1078C17.7854 20.8888 16.3141 21.434 14.3814 21.434C10.9486 21.434 8.03499 19.1206 6.99638 15.923L6.84414 15.9362L2.83707 19.1043L2.78467 19.2532C4.91936 23.5854 9.30419 26.562 14.3814 26.562Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99626 15.923C6.72221 15.0978 6.56361 14.2136 6.56361 13.3001C6.56361 12.3864 6.72221 11.5023 6.98184 10.6771L6.97458 10.5014L2.9173 7.28235L2.78455 7.34686C1.90474 9.14462 1.3999 11.1634 1.3999 13.3001C1.3999 15.4367 1.90474 17.4554 2.78455 19.2532L6.99626 15.923Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3814 5.1659C16.819 5.1659 18.4632 6.24159 19.4008 7.14052L23.0644 3.48608C20.8144 1.34943 17.8863 0.0379639 14.3814 0.0379639C9.30419 0.0379639 4.91936 3.01452 2.78467 7.34674L6.98196 10.677C8.03499 7.47941 10.9486 5.1659 14.3814 5.1659Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9739_6344"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.3999,
    width: 25.4435,
    height: 26.6,
    rx: 12.7217,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.6c4bd4a460e015a93c96de6b90c23f18.svg";
export { ForwardRef as ReactComponent };